import { useIsFocused } from '@react-navigation/native'
import { StackScreenProps } from '@react-navigation/stack'
import { useEffect, useMemo, useState } from 'react'
import MButton from '../../../@ui/buttons/m-button'
import { ScreenWrapper } from '../../../@ui/containers/grid/screen.wrapper'
import { useGlobalStyles } from '../../../contexts/global-styles.provider'
import {
  ContributionStatus,
  ContributionType,
  useContributionsForPerspectiveQuery,
} from '../../../generated/graphql'
import { AppNavigatorParams } from '../../../navigation/types'
import { SocketEvents, useSocketRoom } from '../../../socket/socket.hooks'
import { MelddTaskTargetType } from '../../tasks/task.types'
import { ContributionList } from './components/contribution.list'
import { Contribution, ContributionFilter } from './types'
import { View } from 'react-native'

export function PerspectiveContributionsScreen({
  route,
  navigation,
}: StackScreenProps<AppNavigatorParams, 'PerspectiveContributions'>) {
  const {
    articleId,
    contributionTypeFilter: initTypeFilter,
    contributionStatusFilter: initStatusFilter,
  } = route.params

  const [filter, setFilter] = useState<ContributionFilter>({
    status: initStatusFilter ?? 'All',
    type: initTypeFilter ?? 'All',
  })
  const isFocused = useIsFocused()
  const globalStyles = useGlobalStyles()
  const { data, refetch } = useContributionsForPerspectiveQuery({
    variables: { articleId, status: filter.status, type: filter.type },
    fetchPolicy: 'cache-and-network',
  })

  const contributions: Contribution[] = useMemo(
    () =>
      (data?.contributionsByPerspective || []).filter(
        (c) =>
          c.contributionType != ContributionType.Reserved &&
          c.status != ContributionStatus.Cancelled &&
          c.status != ContributionStatus.Censured
      ),
    [data]
  )
  useSocketRoom(articleId).event(SocketEvents.Refresh, refetch)
  useEffect(() => {
    if (isFocused) {
      refetch()
    }
  }, [isFocused])

  return (
    <ScreenWrapper style={globalStyles.pageContainer}>
      <View
        style={{
          height: globalStyles.pageContainer.height,
        }}
      >
        <ContributionList
          contributions={contributions}
          onContributionPress={(contribution) => {
            navigation.navigate('PerspectiveContribution', {
              contributionId: contribution.id,
            })
          }}
          onFilterChange={(type, status) => {
            setFilter({ status, type })
          }}
          status={filter.status}
          type={filter.type}
        />
      </View>
      <MButton
        targetType={MelddTaskTargetType.ARTICLE_TASK}
        targetId={articleId}
        preview={''}
      />
    </ScreenWrapper>
  )
}
export default PerspectiveContributionsScreen
